// extracted by mini-css-extract-plugin
export default {"cardImageContainer":"cardImageContainer","cardImage":"cardImage"};